export default __webpack_public_path__ + "static/media/screenBlock19.187d8509.jpg";